import { ISetNameParams } from '../types/actionParams';
import { IEmptyResult } from '../types/IResponse';
import { Request } from './Request';

export class SetScheduleNameRequest extends Request<ISetNameParams, IEmptyResult> {
  constructor(id: string, name: string) {
    super('setScheduleName', {
      id: id,
      name: name
    });
  }
}
